export default {
  getSettings(userId) {
    const obj = {
      actionType: appConstants.ActionTypes.GET_SETTINGS,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('USER_ID_PARAM')] = userId;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  changedData(data) {
    const obj = {
      actionType: appConstants.ActionTypes.SETTING_CHANGED,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('USER_ID_PARAM')] = data;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  acceptTOS() {
    const obj = {
      actionType: appConstants.ActionTypes.ACCEPT_TOS,
      data: {
        accepted_tos: true,
      },
    };

    MakeShiftEmployeeDispatcher.dispatch(obj);
  },
};
